import { useState } from "react";

export default props => {
  const [value, setValue] = useState(props);

  const onChange = e => {
    const {
      target: { value }
    } = e;

    setValue(value);
  };
  return { value, onChange, setValue };
};
